import React, { useState, useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

type ToastType = "success" | "error" | "info" | "warning";
type ToastOptions = {
  autoHideDuration?: number;
};

let toastFunction: (type: ToastType, message: string, options?: ToastOptions) => void;

export const Toast = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState<ToastType>("info");
  const [autoHideDuration, setAutoHideDuration] = useState(3000);

  useEffect(() => {
    toastFunction = (toastType, toastMessage, options) => {
      setType(toastType);
      setMessage(toastMessage);
      setAutoHideDuration(options?.autoHideDuration ?? 3000);
      setOpen(true);
    };
  }, []);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert onClose={handleClose} severity={type} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};

export const callToast = (type: ToastType, message: string, options?: ToastOptions) => {
  if (toastFunction) {
    toastFunction(type, message, options);
  } else {
    console.error("Toast component is not initialized.");
  }
};
